var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6446 2.71225C15.2831 2.36984 14.7169 2.36984 14.3554 2.71225C11.8344 5.09972 8.4328 6.56263 4.6875 6.56263C4.62791 6.56263 4.56841 6.56226 4.50901 6.56152C4.0998 6.55644 3.73459 6.81738 3.60677 7.20614C3.09109 8.77459 2.8125 10.4495 2.8125 12.1877C2.8125 19.6152 7.89257 25.8539 14.7663 27.623C14.9196 27.6625 15.0804 27.6625 15.2337 27.623C22.1074 25.8539 27.1875 19.6152 27.1875 12.1877C27.1875 10.4495 26.9089 8.7746 26.3932 7.20614C26.2654 6.81738 25.9002 6.55644 25.491 6.56152C25.4316 6.56226 25.3721 6.56263 25.3125 6.56263C21.5672 6.56263 18.1656 5.09972 15.6446 2.71225ZM19.5129 12.7324C19.8138 12.3111 19.7162 11.7256 19.2949 11.4246C18.8736 11.1237 18.2881 11.2213 17.9871 11.6426L13.9429 17.3045L11.9129 15.2746C11.5468 14.9085 10.9532 14.9085 10.5871 15.2746C10.221 15.6407 10.221 16.2343 10.5871 16.6004L13.3996 19.4129C13.5945 19.6078 13.8652 19.707 14.1398 19.6843C14.4145 19.6616 14.6652 19.5192 14.8254 19.2949L19.5129 12.7324Z",
    fill: "#010F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedId);
export default __webpack_public_path__ + "static/media/verified-id.b49c442d862d5cef9fd6cbfd95805e07.svg";
export { ForwardRef as ReactComponent };